export function toggleChangelog(){
  return {
    type: 'TOGGLE_CHANGELOG',
  }
}